import { render, staticRenderFns } from "./LatestForumItems.vue?vue&type=template&id=581fb511&scoped=true"
import script from "./LatestForumItems.vue?vue&type=script&lang=ts"
export * from "./LatestForumItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581fb511",
  null
  
)

export default component.exports